import Homepage, { getServerSideProps } from './Homepage';
export default Homepage;
export { getServerSideProps };
